// In production, VITE_SERVER_URL is baked at build time (e.g. wss://realtime.ember.tld).
// In dev it falls back to the local server on :2567.
declare const __SERVER_URL__: string;

const configured = typeof __SERVER_URL__ !== "undefined" ? __SERVER_URL__ : "";

function resolveHttp(): string {
  if (configured) return configured.replace(/^ws/, "http");
  return `${location.protocol}//${location.hostname}:2567`;
}

function resolveWs(): string {
  if (configured) return configured.replace(/^http/, "ws");
  const proto = location.protocol === "https:" ? "wss" : "ws";
  return `${proto}://${location.hostname}:2567`;
}

export const HTTP_URL = resolveHttp();
export const WS_URL = resolveWs();
